<template>
  <div class="header">
    <div class="header-left">
      <div class="block header-left-time">{{currentTime.date}}</div>
      <div class="block">{{currentTime.week}} {{ currentTime.time }}</div>
    </div>
    <div class="logo">
      <img class="logo_title" src="@/assets/images/signIn/aiqxpcfxpt.png" alt="" />
    </div>

    <div class="handle">
      <template v-if="!isVideoPage">
        <div class="block dropdown">
          <el-dropdown popper-class="header-popper" :teleported="false" trigger="click">
            <span class="el-dropdown-link">
              <SvgIcon name="header_right_ava" class="icon-size"></SvgIcon>
              <span style="color: #4aefff">{{ USERINFO.userName }}</span>
              <SvgIcon name="header-arrow" class="icon-size-arrow"></SvgIcon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="">个人信息</el-dropdown-item>
                <el-dropdown-item @click="editPassWord">修改密码</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <div class="block resetLogin" @click="logout">
          <SvgIcon name="header_right_off" class="icon-size"></SvgIcon>
          <span>退出登录</span>
        </div>
      </template>
      <template v-else>
        <div class="block resetLogin" @click="tuichu">
          <SvgIcon name="header_right_off" class="icon-size"></SvgIcon>
          <span>退出</span>
        </div>
      </template>
    </div>
    <Dialog
      width="500px"
      v-model="dialogImgVisible"
      title="修改密码"
      top="5vh"
    >
      <editPassword @cancel="dialogImgVisible = false" />
    </Dialog>
  </div>
</template>

<script setup>
import { useThemeStore } from "@/store/theme.js";
import { local } from "@/utils/storage.js";
import { useRouter } from "vue-router";
import { computed, inject, ref, onMounted, onUnmounted, nextTick } from "vue";
import emitter from "@/utils/bus.js";
import { ElMessageBox, ElDialog } from "element-plus";
// import routes from "@/router/routes.js"
// import VButtonAuth from "@/directives/VButtonAuth.js";
import { useStore } from "@/store/index.js";
import editPassword from "../../../view/admin/editPassword/editPassword.vue";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");

const props = defineProps({
  isVideoPage: {
    type: Boolean,
    default: false,
  }
})
const tuichu=()=>{
  if(window.global_config.LoginType === 1){
      router.replace('/AiVideo')
  }
  if(window.global_config.LoginType === 2){
      router.replace('/new_AiVideo')
  }
}
onMounted(() => {
  timer.value = setInterval(() => {
    currentTime.value = {
      date: dayjs().format("YYYY年MM月DD日"),
      week: dayjs().format("ddd"),
      time: dayjs().format("HH:mm:ss"),
    }
  },1000)
})
onUnmounted(() => {
  clearInterval(timer.value)
})

const timer = ref(null);
const currentTime = ref({
  date: dayjs().format("YYYY年MM月DD日"),
  week: dayjs().format("ddd"),
  time: dayjs().format("HH:mm:ss"),
})

const themeStore = useThemeStore();
const router = useRouter();
const store = useStore();
const USERINFO = inject("USERINFO", {});
const dialogImgVisible = ref(false);
// 字体改变回调
const changeFontSize = (size) => {
  themeStore.setFontSize(size);
  themeStore.setElementPlusCom_size(size);
  emitter.emit("ChangeFontSize", size);
};

const organizationName = computed(() => local.get("organizationName"));

// 退出登录
const logout = () => {
  ElMessageBox.confirm("确定要退出登录吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    store.clearLocalStorage();
    // window.location.reload();
    nextTick(() => router.replace("/login"));
  });
};

// 修改密码
const editPassWord = () => {
  // router.replace("/editPassWord")
  console.log("修改密码");
  dialogImgVisible.value = true;
};
</script>

<style scoped lang="scss">
:deep() {
  .header-popper{
    min-width: 160px;
    background-color: var(--themed-color2);
    border-color: var(--themed-color2);
  }
  .el-dropdown-menu{
    background-color: var(--themed-color2);
  }
  .el-dropdown-menu__item{
    justify-content: center;
    background-color: var(--themed-color2);
    color: #6fcaf7;
  }
  .el-dropdown-menu__item:not(.is-disabled):focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: var(--themed-color2);
    color: #4aefff;
  }
  .el-popper__arrow::before{
    background-color: var(--themed-color2) !important;
    border-color: var(--themed-color2) !important;
  }
}
.header {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: url("@/assets/svgs/header_bg.svg#svgView(preserveAspectRatio(none))") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .block{
    min-width: 200px;
    height: 46px;
    line-height: 46px;
    color: #4aefff;
    background: url("@/assets/svgs/header_kuai.svg#svgView(preserveAspectRatio(none))") no-repeat center center;
    background-size: 100% 100%;
    text-align: center;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .header-left {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  .logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .logo_title {
      width: 312px;
      height: 36px;
      vertical-align: middle;
    }
  }

  .handle {
    display: flex;
    align-items: center;
    gap: 10px;
    & > span {
      font-size: 16px;
      font-weight: 400;
      color: #4aefff;
    }
    .dropdown,.resetLogin {
      cursor: pointer;
    }
    .resetLogin{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
    }
    .icon-size {
      width: 20px !important;
      height: 20px !important;
    }

    .icon-size-arrow {
      width: 14px !important;
      height: 6px !important;
    }
    .el-dropdown{
      height: 100%;
    }
    .el-dropdown-link {
      display: flex;
      align-items: center;
      line-height: 46px;
      text-align: center;
      gap: 5px;
    }
  }
}
</style>
